export const renderTemplate = (template = '', data = {}) => {
  if (!template) return '';
  return template.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
    const value = data[key];
    if (value === null || value === undefined) return '';
    return String(value);
  });
};
